import { format } from "date-fns-tz"

export var skud_model = {
    count: 0,
    skudLogs: [{
        pass_revision: 0,
        pass_count: 0,
        last_sync_at: format(new Date(), "yyyy-MM-dd"),
        queue_pending: 0,
        queue_oldest_at: format(new Date(), "yyyy-MM-dd"),
        last_command_id: "",
        mode: "",
        screen: "",
        reader_ok: false,
        camera_ok: false,
        face_engine: "",
        offline_decisions_last_hour: 0,
        clock_skew_sec: 0,
        maintenance: false,
        manual_direction: ""
    }]
}

export var skud_log_headers = [
    {
        value: 'last_sync_at',
        text: 'Дата/время'
    },
    {
        value: 'pass_revision',
        text: 'pass_revision'
    },
    {
        value: 'pass_count',
        text: 'Сообщение'
    },
    {
        value: 'queue_pending',
        text: 'queue_pending'
    }, {
        value: 'last_command_id',
        text: 'last_command_id'
    }, {
        value: 'mode',
        text: 'mode'
    }, {
        value: 'screen',
        text: 'screen'
    }, {
        value: 'reader_ok',
        text: 'reader_ok'
    }, {
        value: 'camera_ok',
        text: 'camera_ok'
    }, {
        value: 'face_engine',
        text: 'face_engine'
    }, {
        value: 'offline_decisions_last_hour',
        text: 'offline_decisions_last_hour'
    }, {
        value: 'clock_skew_sec',
        text: 'clock_skew_sec'
    }, {
        value: 'maintenance',
        text: 'maintenance'
    }, {
        value: 'manual_direction',
        text: 'manual_direction'
    },
]
